<template>
  <main class="text-notification-picker" data-cy="text-notification-picker">

    <div class="border border-solid border-blue rounded-2xl p-2 cursor-pointer"
         :class="selected ? 'text-white bg-blue' : 'text-blue bg-white'"
         @click="openModal">
      <div v-if="!selected" class="notification-label">
        select sms notification message
      </div>
      <template v-if="selected">
        <div class="notification-label">
          {{ selected.title }}
        </div>
        <div class="notification-label-description">
          {{ selected.message }}
        </div>
      </template>
    </div>

    <simple-modal
      v-if="isModalOpen"
      class="notification-modal font-secondary"
      :class="{'show-footer': selectedTemplate != null}"
      title="select sms notification message"
      @rejected="closeModal"
      @resolved="$emit('update:selected', selectedTemplate); closeModal()"
    >
      <tab-bar :tabs="tabs" :selected.sync="selectedTab" class="my-6 px-4" />
      <div class="notif-list overflow-y-auto text-center">
        <transition-group v-if="displayedTemplates.length" name="notif-messages-list" tag="div" class="relative border-0 border-t-1 border-solid border-gray-300 leading-5 cursor-default">
          <div class="notif-item flex items-center border border-solid border-gray-300 border-t-0 p-2 cursor-pointer"
               :class="{'selected bg-blue text-white' : selectedTemplate && selectedTemplate.id === template.id}"
               v-for="template in displayedTemplates"
               :key="template.id"
               @click="selectedTemplate = template"
          >
            <div class="flex-1 pr-2 text-left text-sm">
              <div v-if="template.title" :class="{'text-blue' : !selectedTemplate || selectedTemplate.id !== template.id}">
                {{ template.title }}
              </div>
              <div>{{ template.message }}</div>
            </div>
            <fai class="like-icon p-1 mr-1 cursor-pointer hover:text-red-500 hover:opacity-100"
                 :class="[template.liked ? 'text-red-500 opacity-100' : 'opacity-40']"
                 :icon="[(template.liked ? 'fas' : 'far'), 'heart']"
                 @click.stop="!template.liked ? likeMessage(template) : undoLikeMessage(template)"
            />
            <fai class="delete-icon p-1 mr-1 cursor-pointer opacity-40 hover:opacity-100"
                 :icon="['far', 'trash-can']"
                 @click.stop="deleteMessage(template)"
            />
          </div>
        </transition-group>
        <div v-else class="flex h-full items-center justify-center">
          <LoadingIcon v-if="isLoading" />
          <span v-else>no messages to display</span>
        </div>
      </div>
      <div class="toast-container absolute bottom-0 flex items-baseline justify-center w-full" :class="{'show-toast': isToastDisplayed}">
        <div class="toast border border-solid border-blue-300 bg-blue-100 rounded px-10 py-2 text-center">
          sms notification message succesfully deleted. <a class="bold" @click="undoDeleteMessage">click here to undo</a>
        </div>
      </div>
    </simple-modal>
  </main>
</template>

<script>
import { SimpleModal, TabBar, LoadingIcon } from "@springbig/sb-components"
import { notificationMessagesAPI } from "../services/api/notificationMessagesAPI"
const tabs = [
  {key: 'recently_used', label: 'recently used'},
  {key: 'favorites', label: 'favorites'},
  {key: 'custom', label: 'custom'},
  {key: 'general', label: 'general'},
];

export default {
  name: 'text-notification-picker',
  components: {
    SimpleModal,
    TabBar,
    LoadingIcon
  },
  props: {
    templates: {
      type: Object,
      default: {
        general: [],
        custom: [],
        favorites: [],
        recently_used: [],
      },
    },
    selected: [ String, Number, Object ],
    campaignId: String,
    autoCampaignId: String,
    isLoading: Boolean,
  },
  data() {
    return {
      tabs,
      selectedTab: tabs[3],
      selectedTemplate: null,
      isModalOpen: false,
      isToastDisplayed: false,
      lastDeletedTemplate: null,
      undeleteMessageToastTimeout: null
    }
  },
  computed: {
    displayedTemplates() {
      return this.templates[this.selectedTab.key];
    },
    requestParams() {
      if(this.campaignId) {
        return {campaign_id: this.campaignId}
      }else if(this.autoCampaignId) {
        return {auto_campaign_id: this.autoCampaignId}
      }
    },
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedTemplate = null;
      this.lastDeletedTemplate = null;
    },
    likeMessage(template) {
      notificationMessagesAPI.likeMessage(template.id, this.requestParams)
        .then(() => { this.$emit('triggerUpdate') })
    },
    undoLikeMessage(template) {
      notificationMessagesAPI.unlikeMessage(template.id, this.requestParams)
        .then(() => { this.$emit('triggerUpdate') })
    },
    deleteMessage(template) {
      notificationMessagesAPI.deleteMessage(template.id, this.requestParams)
        .then(() => {
          this.lastDeletedTemplate = template;
          this.showUndoDeleteToast();
          this.$emit('triggerUpdate');
        })
    },
    undoDeleteMessage() {
      window.clearTimeout(this.undeleteMessageToastTimeout)
      notificationMessagesAPI.undoDeleteMessage(this.lastDeletedTemplate.id, this.requestParams)
        .then(() => {
          this.lastDeletedTemplate = null;
          this.isToastDisplayed = false;
          this.$emit('triggerUpdate');
        })
    },
    showUndoDeleteToast() {
      this.isToastDisplayed = true;
      this.undeleteMessageToastTimeout = window.setTimeout(()=>{
        this.lastDeletedTemplate = null;
        this.isToastDisplayed = false;
      }, 7000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .data-description b {
    font-size: 1.25rem;
  }
  .toast-container {
    position: absolute;
    height: 60px;
    bottom: -60px;
    transition: bottom ease .5s;
    &.show-toast {
      bottom: 0;
    }
  }
  .notification-modal::v-deep {
    &.show-footer footer { display: flex; }
    > div {
      height: 100%;
      max-height: 750px;
      width: 650px;
      display: flex;
      flex-direction: column;
      padding-bottom: 0;
      overflow-y: hidden;
      section.content {
        position: relative;
        display: flex;
        flex: 1;
        overflow: hidden;
        flex-direction: column;
        margin: 0 -1em;
        >.notif-list {
          padding: 0 1em 1em;
          flex: 1;
        }
      }
      footer {
        display: none;
        margin: 0 -1em;
        border-top: 1px solid #128ff9;
        padding: 1em;
        .sb-button {
          border-radius: 100px;
        }
        .sb-reject {
          display: none;
        }
      }
    }
  }
  .sb-tab-bar::v-deep {
    overflow: initial;
    border: none;
    flex-direction: row-reverse;
    margin-left: 10px;
    margin-right: 10px;
    > div {
      text-align: center;
      border-radius: 14px;
      border: 1px solid #128ff9;
      margin-left: -10px;
      margin-right: -10px;
      padding: 10px 24px;
      font-size: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &:not(.invert) {
        z-index: 0;
      }
      @media only screen and (max-width: 600px) {
        font-size: 12px;
      }
    }
  }

  .notif-messages-list-move,
  .notif-messages-list-enter-active,
  .notif-messages-list-leave-active {
    transition: all .5s ease;
  }
  .notif-messages-list-enter-from,
  .notif-messages-list-leave-to {
    opacity: 0;
  }
  .notif-messages-list-leave-active {
    position: absolute;
  }

</style>
